import { Input, Component, OnInit, OnDestroy } from '@angular/core';
import { get, set } from 'lodash';
import { ConfigurationStoreHandler } from '../../../configuration/services/configuration-store-handler.service';
import { takeUntil } from 'rxjs/operators';
import { TherapiesActionCreatorService } from '@ispm/therapies/services/therapies-action-creator.service';
import {Subject} from "rxjs/Subject";

const CLINICAL_RECOMMENDATION_TYPE_NAME = 'CLINICALRECOMMENDATION';
const CLINICAL_TRIAL_TYPE_NAME = 'CLINICALTRIAL';

@Component({
  selector: 'gen-expandable-information-card-wrapper',
  templateUrl: './expandable-information-card-wrapper.component.html',
  styleUrls: ['./expandable-information-card-wrapper.component.scss'],
})
export class ExpandableInformationCardWrapperComponent implements OnInit, OnDestroy {


  @Input()
  public set data(d) {
    this._data = d;
  }

  public get data() {
    return this._data;
  }

  public testId: string;

  @Input()
  public set panelConfiguration(config: any) {
    this._panelConfiguration = config;
  }

  public get panelConfiguration(): any {
    return this._panelConfiguration;
  }

  public additionalData: any = { };
  public indexProperty: string = 'id';

  private _data: any;
  public  dataLazy: any = [];
  private _panelConfiguration: any;

  private componentDestroyer$: Subject<void> = new Subject<void>();

  constructor(
    private configurationAC: ConfigurationStoreHandler,
    private therapyAC: TherapiesActionCreatorService,
  ) {
  }

  ngOnInit() {
    this.configurationAC.getCurrentConfig()
      .pipe(takeUntil(this.componentDestroyer$.asObservable()))
      .subscribe(testDefinition => this.testId = testDefinition.id);

    this.indexProperty = this.panelConfiguration.indexProperty || this.indexProperty ;

  }

  ngOnDestroy() {
    this.componentDestroyer$.next();
    this.componentDestroyer$.complete();
  }

  trackById(index, item) {
    return get(item, 'id', index) + '_' + get(item, 'meta.versionId', index); // for handling edit cases
  }

  trackByIndex(index) {
    return index;
  }

  addToSelection(item) {
    let storeItem = item;

    if (item.resourceType && item.resourceType.toUpperCase() === CLINICAL_RECOMMENDATION_TYPE_NAME) {
      if(item.clinicalRecommendationType.toUpperCase()  === CLINICAL_TRIAL_TYPE_NAME){ //Clinical trials are fetched as clinical recommendation with clinicalRecommendationType == 'ClinicalTrial'
        storeItem = {
          id: item.id,
          resourceType: item.resourceType.toLowerCase(),
          trialID: item.trialID,
          target: item.target,
          source: item.source,
          name: item.name,
          clinicalRecommendationType: item.clinicalRecommendationType
        };
      }
      else {
        storeItem = {
          id: item.id,
          resourceType: item.resourceType.toLowerCase(),
          displayName: item.therapy.display,
          drugBankVersion: undefined,
          name: item.therapy.display,
          source: item.therapy.source,
        };

        if (Array.isArray(item.therapy.drugs)) {
          set(storeItem, 'drugIds', [get(item.therapy.drugs[0], 'code'), get(item.therapy.drugs[0], 'code')]);
        }

        if (Array.isArray(item.requiredCondition.requiredBiomarkers)) {
          const target = [];

          item.requiredCondition.requiredBiomarkers.forEach(bioMarker => {
            target.push(bioMarker.display);
          });

          set(storeItem, 'target', target);
        }
      }
    }
    this.therapyAC.addTherapy(storeItem as any, this.indexProperty);
  }

  removeFromSelection(item) {
    this.therapyAC.removeTherapyFromPriority(item, this.indexProperty);
  }

}
